import { render, staticRenderFns } from "./entity-sidepanel.vue?vue&type=template&id=1431f3b6&scoped=true&"
import script from "./entity-sidepanel.vue?vue&type=script&lang=js&"
export * from "./entity-sidepanel.vue?vue&type=script&lang=js&"
import style0 from "./entity-sidepanel.vue?vue&type=style&index=0&id=1431f3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431f3b6",
  null
  
)

export default component.exports